import { SET_AVATAR_OPTIONS, START_AVATAR_SELECTION, ROOM_NOT_FOUND_ERROR, START_SOCIAL_LOGIN, SET_ROOM_CODE, SET_USER_NAME, LoginVersions, LoginStates, RESET_BIOS_INPUT } from '../actions/login';

const loginVersion = LoginVersions.USERNAME;
const initialLoginStep = LoginStates.USERNAME;

const initialLoginState = {
    loginType: loginVersion, // Login version - should come from config or API
    roomCode: {
        hasError: false,
        isHardcoded: false,
        code: null
    },
    avatarSelectionEnabled: true,
    facebookEnabled: true,
    googleEnabled: true,
    accountLoginEnabled: true,
    userName: null,

    currentLoginStep: initialLoginStep,
    avatars: []
}

const loginState = (state = initialLoginState, action) => {
  switch (action.type) {
    case SET_AVATAR_OPTIONS:
      return { ...state, avatars: action.avatars };        
    case SET_ROOM_CODE:
      return { ...state, roomCode: {code: action.roomCode, isHardcoded: false} };
    case SET_USER_NAME:
      return { ...state, userName: action.name };
    case START_SOCIAL_LOGIN:
      return { ...state, currentLoginStep: LoginStates.SOCIAL_HOME };
    case START_AVATAR_SELECTION:
      return { ...state, currentLoginStep: LoginStates.AVATAR };
    case ROOM_NOT_FOUND_ERROR:
      return { ...state, roomCode: {hasError: true, isHardcoded: false, code: null}}
    case RESET_BIOS_INPUT:
      return { ...state, roomCode: {hasError: false, isHardcoded: false, code: null}}
    default:
      return state
  }
}
  
export default loginState;


// WEBPACK FOOTER //
// ./src/components/store/reducers/login.js